import { cloneDeep } from 'lodash';
import { supabase } from '../supabaseClient';

async function getAllLaunchesByEvent(eventId) {
    let query = supabase.from('Launches').select('*,projectId(*)').eq('eventId', eventId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function getAllLaunchesByEventForSettings(eventId) {
    let query = supabase.rpc('getuniqueunittypesforcolorselection', { pid: eventId })
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function getLaunchById(launchId) {
    let query = supabase.from('Launches').select('*,projectId(*)').eq('launchId', launchId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function addLaunch(launch) {
    launch.created_at = Date.now()
    const { data, error } = await supabase.from('Launches').insert(launch)
    if (data) return data
    else throw error
}

async function editLaunch(obj, launchId) {
    console.log(obj)
    obj.last_updated_at = Date.now()
    const { data, error } = await supabase.from('Launches').update(obj).eq('launchId', launchId)
    if (data) return data
    else throw error
}

async function getLaunchByTitle(title, eventId) {
    const { data, error } = await supabase.from('Launches').select('*').ilike('title', `%${title}%`).eq('eventId', eventId)
    if (data) return data
    else throw error
}

async function getAllCpByLaunch(launchId) {
    let query = supabase.from('LaunchCpRelations').select('*').eq('launchId', launchId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function getAllSalesByLaunch(launchId) {
    let query = supabase.from('LaunchSalesRelations').select('*').eq('launchId', launchId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function getAllSalesByProject(projectId) {
    let query = supabase.from('SustenanceSalesRelations').select('*').eq('projectId', projectId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}
async function getAllSalesByProjectWings(projectId,wingId) {
    let query = supabase.from('SustenanceWingsSalesRelations').select('*').eq('projectId', projectId).eq('wingId', wingId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}
async function getAllSalesByProjectFloors(projectId,wingId,floorNo) {
    let query = supabase.from('SustenanceFloorsSalesRelations').select('*').ilike('floorNo', `%${floorNo}%`).eq('projectId', projectId).eq('wingId', wingId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}
async function insertIntoSalesRelations(obj) {
    obj.created_at = Date.now()
    let query = supabase.from('LaunchSalesRelations').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deleteSalesRelations(obj, launchId) {
    let query = supabase.from('LaunchSalesRelations').delete().eq('launchId', launchId).eq('userId', obj.userId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function insertIntoCpRelations(obj) {
    obj.created_at = Date.now()
    let query = supabase.from('LaunchCpRelations').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deleteCpRelations(obj, launchId) {
    let query = supabase.from('LaunchCpRelations').delete().eq('launchId', launchId).eq('cpId', obj.cpId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}
async function insertIntoPriceListRelations(obj) {
    obj.created_at = Date.now()
    let query = supabase.from('LaunchPricingRelations ').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deletePriceListRelations(obj, launchId) {
    let query = supabase.from('LaunchPricingRelations ').delete().eq('launchId', launchId).eq('projectPricingId', obj.projectPricingId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}


async function insertIntoPaymentRelations(obj) {
    obj.created_at = Date.now()
    let query = supabase.from('LaunchPaymentPlanRelations').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deletePaymentRelations(obj, launchId) {
    let query = supabase.from('LaunchPaymentPlanRelations').delete().eq('launchId', launchId).eq('paymentPlanId', obj.paymentPlanId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function updateLaunch(id, obj) {
    let newobj = cloneDeep(obj);
    newobj.last_updated_at = Date.now();
    const { data, error } = await supabase
      .from("Launches")
      .update(newobj)
      .eq("launchId", id);
    if (data) return data;
    else throw error;
  }

  const getLaunchTokenById =async (launchId) => {
    let query = supabase.from('PreselectInventoryRelations').select('*,eventTokenId(*,tokenId(*))').eq('launchId', launchId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
  }

 

  const  getTokenPreselectInfoById =async (eventId,eventTokenId,launchId) => {
    let query = supabase.from('PreselectConfirmationConfig').select('*').eq("eventId",eventId).eq('eventTokenId', eventTokenId).eq("launchId",launchId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
  }

  async function insertIntoPreselectConfirmationConfig(obj) {
    let query = supabase.from('PreselectConfirmationConfig').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
} 
async function updateIntoPreselectConfirmationConfig(obj) {
  const { data, error } = await supabase
    .from("PreselectConfirmationConfig")
    .update(obj)
    .eq("launchId", obj.launchId)
    .eq("eventId", obj.eventId)
    .eq("eventTokenId", obj.eventTokenId);
  if (data) return data;
  else throw error;
} 


export { updateIntoPreselectConfirmationConfig, insertIntoPreselectConfirmationConfig,getTokenPreselectInfoById,getLaunchTokenById,getLaunchByTitle, getAllLaunchesByEvent, addLaunch, editLaunch, insertIntoPaymentRelations, deletePaymentRelations, getLaunchById, getAllCpByLaunch, getAllSalesByLaunch, getAllLaunchesByEventForSettings, insertIntoSalesRelations, deleteSalesRelations, insertIntoCpRelations, deleteCpRelations , insertIntoPriceListRelations , deletePriceListRelations , getAllSalesByProject,updateLaunch,getAllSalesByProjectWings,getAllSalesByProjectFloors}

